import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { getRoles } from "../../utils/OktaHelpers";
import { isAuthorized } from "../../utils/RolesHelpers";
import { GLOBAL_ROUTES } from "../../utils/RoutesConstant";
import { UserContext } from "../../lib/MainContext";
import SplashScreenView from "../../views/Shared/SplashScreenView";
import { isEmpty } from "lodash";

const PrivateRoute = ({
    allowedRoles,
    redirect = GLOBAL_ROUTES.PageNotFound,
    forbidden,
}) => {
    const roles = getRoles();
    const { isLoggingOut } = useContext(UserContext);
    if (isLoggingOut || isEmpty(roles)) {
        return <SplashScreenView />;
    }

    return !forbidden &&
        (!allowedRoles || isAuthorized(allowedRoles, roles)) ? (
        <Outlet />
    ) : (
        <Navigate replace to={redirect} />
    );
};
export default PrivateRoute;
